import React, { useState } from 'react'
import data from './data.json'

function Summary() {
  const [back, setback] = useState('btn btn-primary');
  const handleClick=(e)=>{
      e.preventDefault();
      setback('btn btn-dark');
  }
  return (
    <div className='col-lg-3 card shadow rounded-end-4 py-3'>
      <div>
        <b>Summary</b>
        {data.map((element) => (
          <div
            className={`my-4 py-3 px-3 rounded-2 d-flex justify-content-between ${
              element.category === 'Reaction'
                ? 'bg-danger-subtle'
                : element.category === 'Memory'
                ? 'bg-warning-subtle'
                : element.category === 'Verbal'
                ? 'bg-success-subtle'
                : 'bg-primary-subtle'
            }`}
            key={element.score}
          >
            <div>
              <img src={element.icon} alt="" />
              <label className={`fw-bold mx-2 ${
              element.category === 'Reaction'
                ? 'text-danger'
                : element.category === 'Memory'
                ? 'text-warning'
                : element.category === 'Verbal'
                ? 'text-success'
                : 'text-primary'
            }`}>{element.category}</label>
            </div>
            <div><b>{element.score}<span className='text-black text-opacity-25'> / 100</span></b></div>
          </div>
        ))}
      </div>
      <button className={`rounded-pill w-100 py-2 ${back}`} onClick={handleClick}>Continue</button>
    </div>
  )
}

export default Summary
